module.exports = __webpack_public_path__ + "img/overflow-white.753cd252.svg";